import styled from "styled-components"

export const Einleitung = styled.article`
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  flex-direction: column;
  overflow: hidden;
  margin: 0 auto;

  .logo {
    width: 160px;
    height: 160px;
    margin-top: var(--gapXS);
    margin-bottom: var(--gapS);
    svg {
      width: 100%;
      height: 100%;
    }
  }
`

export const Background = styled.div`
  position: absolute;
  width: 100%;
  padding-bottom: 20%;
  min-width: 932px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  justify-content: space-between;
  z-index: -1;
  overflow: hidden;

  .icon__container {
    position: relative;
    width: 60%;
    padding-bottom: 40%;
    max-width: 435px;
    max-height: 470px;
    &:first-child {
      margin-right: 50%;
    }
  }

  @media (max-width: 992px) {
    display: none;
    visibility: hidden;
  }
`

export const Überschrift = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  text-align: center;
  padding: 0 15px;

  h1 {
    font-size: var(--fontSize-1);
  }

  div {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    justify-content: space-between;
    width: 100%;
    max-width: 350px;
    margin-top: 10px;
    span {
      font-size: var(--fontSize-0);
      color: var(--clr-gold);
    }
  }
`

export const EinleitungsText = styled.div`
  width: 100%;
  padding: 50px 100px;
  margin-top: var(--gapL);
  background: var(--clr-white-purple);
  border-radius: var(--border-radius-secondary);

  p {
    color: var(--clr-purple);
  }
`

/*
=============== 
Kontakt
===============
*/

export const Kontakt = styled.article`
  max-width: var(--maxWidthPrimary);
  width: 100%;
  margin: 0 auto;

  & > h2 {
    text-align: center;
    margin-bottom: var(--gapM);
    padding: 0 5px;
  }
`

/*
=============== 
Main
===============
*/

export const Main = styled.main`
  max-width: var(--maxWidthPrimary);
  margin-right: auto;
  margin-left: auto;
  padding: 0 5px;
  margin-bottom: 0;

  & > article,
  & > ul {
    margin-top: 100px;
    margin-bottom: 100px;
  }

  & > article:first-child {
    margin-top: var(--gapS);
  }

  @media (max-width: 768px) {
    padding: 0 15px;

    ${Kontakt} {
      h2 {
        font-size: var(--fontSize-1);
      }
    }

    ${Einleitung} {
      padding: 0;
    }
    ${EinleitungsText} {
      border-radius: 0;
      padding: 35px;
    }

    ${Überschrift} {
      h1 {
        font-size: var(--fontSize-0);
      }

      div {
        width: 100vw;
        padding: 0 15px;
      }
    }
  }
`
